import ActionBar from './ActionBar'
import List from './List'
import SalesTypeDetail from './SalesTypeDetail'
import {connect} from 'react-redux'
import {
  salesTypePageRequest,
  cancelDelete,
  cancelActivated,
  deleteSalesType,
  activatedSalesType
} from 'actions/library/salesType'
import NoDataAndLoading from 'components/NoDataAndLoading'
import LibraryDeleteModal from './LibraryDeleteModal'
import LibraryActivateModalSalesType from 'components/LibraryActivateModalSalesType'
import {askConfirmAction} from 'actions/confirm-action'
import {isDirty, getFormValues} from 'redux-form'
import {browserHistory} from 'react-router'
import {push} from 'react-router-redux'
import ConfirmActionModal from 'components/ConfirmActionModal'
import {ContentWrapper, LeftColumnWrapper, RightColumnWrapper, PageWrapper} from 'components/wrappers/pages'
import SaveToAllOutletsModal from './SaveToAllOutletsModal'
import {shouldShowSalesTypeLibrary, hideSalesTypeLibrary} from 'utils/ftue'
import * as mpLibrarySalesType from 'mixpanel/library/salesType'
import styles from './SalesType.css'

class SalesType extends React.Component {
  render () {
    let {salesTypeDetail, isSubmittingForm, showDeleteModal, showActivatedModal, deletedSalesType, activatedSalesType, openRightColumn, showLoadingSpinnerPage, salesType, showSaveToAllOutletsModal} = this.props
    let salesTypeName = deletedSalesType ? deletedSalesType.name : ''
    let textModalTitle = salesTypeDetail && salesTypeDetail.active_state === true ? 'Deactivate Sales Type' : 'Reactivate Sales Type'
    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={salesType.length === 0}
              title='No Data To Display'
              description={<div>Learn more about <a className={styles['link-creating-sales-type']} onClick={this._onClickKnowledgeProducTracking} href='https://mokaposhelp.zendesk.com/hc/en-us/articles/115003477774' target='_blank'>Create Sales Type</a></div>}
            />
            <List />
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <SalesTypeDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        <LibraryDeleteModal
          showDeleteModal={showDeleteModal}
          onHide={this._onHideModal}
          title='Sales Type'
          name={salesTypeName}
          onDelete={this._onDelete}
          isSubmittingForm={isSubmittingForm}
        />
        <LibraryActivateModalSalesType
          showActivatedModal={showActivatedModal}
          onHide={this._onHideModalActivated}
          title={textModalTitle}
          name={activatedSalesType}
          onActivated={this._onActivated}
          isActivate={salesTypeDetail}
        />
        <ConfirmActionModal />
        {showSaveToAllOutletsModal && <SaveToAllOutletsModal />}
      </PageWrapper>
    )
  }

  componentDidMount () {
    // TODO refactor move it to index or routes
    axios.interceptors.request.use(function (config) {
      let rememberToken = Cookies.get('remember_token')
      if (config.url.startsWith('https://service-experiment')) {
        config.headers['Authorization'] = rememberToken
      }
      return config
    }, function (error) {
      // Do something with request error
      return Promise.reject(error)
    })
    const {expired} = this.props
    if (!expired) {
      mpLibrarySalesType.salesTypeStart()
      this.props.dispatch(salesTypePageRequest())
      browserHistory.listenBefore((location) => {
        // this is still hacky, don't copy paste this
        if (this.props.isDirtySalesType && !this.props.nextAction) {
          this.props.dispatch(askConfirmAction(push(location)))
          return false
        }
      })
    } else {
      browserHistory.push('/settings/billing')
    }
  }
  componentWillUnmount () {
    if (shouldShowSalesTypeLibrary()) {
      hideSalesTypeLibrary()
    }
  }

  _onDelete = () => {
    let {dispatch, salesType, outlets, deletedSalesType, currentOutletId} = this.props
    dispatch(deleteSalesType(outlets, currentOutletId, deletedSalesType.id, deletedSalesType.business_id, salesType))
  }

  _onActivated = (salesTypeDetail) => {
    let {dispatch, salesType, outlets, currentOutletId} = this.props
    dispatch(activatedSalesType(outlets, currentOutletId, salesTypeDetail, salesType))
  }

  _onHideModal = () => {
    this.props.dispatch(cancelDelete())
  }

  _onHideModalActivated = () => {
    this.props.dispatch(cancelActivated())
  }
}

function mapStateToProps (state) {
  let {salesType, outlets, isSubmittingForm, salesTypeDetail, showDeleteModal, showActivatedModal, deletedSalesType, activatedSalesType, openRightColumn, showSaveToAllOutletsModal} = state.library.salesType
  const isDirtySalesType = isDirty('salesType')(state)
  const {nextAction} = state.confirmAction
  const {showLoadingSpinnerPage} = state.loadingSpinner
  const {expired} = state.subscriptionExpired
  const currentOutletId = getFormValues('search')(state)
  return {
    salesType,
    salesTypeDetail,
    showDeleteModal,
    showActivatedModal,
    deletedSalesType,
    activatedSalesType,
    isDirtySalesType,
    nextAction,
    openRightColumn,
    showLoadingSpinnerPage,
    expired,
    showSaveToAllOutletsModal,
    currentOutletId,
    outlets,
    isSubmittingForm
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesType)



// WEBPACK FOOTER //
// ./app/pages/Library/SalesType/SalesType.js